"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileLoginInfoEdit = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const elements_1 = require("@src/components/elements");
const LoginInfoEditForm_1 = require("@src/components/modules/global/LoginInfoEditForm");
const ProfileLoginInfoEdit = () => {
    return ((0, jsx_runtime_1.jsx)(elements_1.Panel, { children: (0, jsx_runtime_1.jsx)(LoginInfoEditForm_1.LoginInfoEditForm, { showNewsletterField: true }) }));
};
exports.ProfileLoginInfoEdit = ProfileLoginInfoEdit;
